import { Chip } from '@mui/material';
import { getSpacing } from '@/styles/theme';

interface TagProps {
  text: string;
  backgroundColor: string;
  color: string;
}

const Tag = ({ text, backgroundColor, color }: TagProps) => {
  return (
    <Chip
      label={text}
      size='small'
      sx={{
        mr: getSpacing.sm,
        mb: getSpacing.sm,
        fontSize: '0.75rem',
        height: 24,
        px: 1.5,
        backgroundColor: backgroundColor,
        color: color,
        fontWeight: (theme) => theme.customFontWeights.medium,
      }}
    />
  );
};

export default Tag;
